import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getAgrupacionesProveedores (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getUsers
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      if (params !== null) {
        clone.data = clone.data.slice(0, params.limit)
      }

      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/sociedad/getAgrupacionesProveedores',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getAgrupacionesProveedores }
